import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, Inject, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { Store } from '@ngrx/store';

import { QuotesActions } from '../../../@store/quotes/quotes.actions';
import {
  selectDeletedQuoteError,
  selectDeletedQuoteSuccess,
} from '../../../@store/quotes/quotes.selectors';

@Component({
  selector: 'ciwc-delete-quote-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  templateUrl: './delete-quote-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteQuoteDialogComponent {
  private readonly store = inject(Store);
  readonly deletedQuoteSuccess = this.store.selectSignal(selectDeletedQuoteSuccess);
  readonly deletedQuoteError = this.store.selectSignal(selectDeletedQuoteError);

  isDeleting = signal(false);

  constructor(
    public dialogRef: MatDialogRef<DeleteQuoteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { quoteId: string },
  ) {
    effect(() => {
      if (this.isDeleting()) {
        if (this.deletedQuoteSuccess()) {
          this.dialogRef.close();
        }

        if (this.deletedQuoteError()) {
          this.isDeleting.set(false);
        }
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    this.isDeleting.set(true);

    this.store.dispatch(QuotesActions.deleteQuote({ id: this.data.quoteId }));
  }
}
